export class Table {
  constructor(headers, rows) {
    this._headers = headers;
    this._rows = rows;
    this.widths = columnWidths([headers, ...rows]);
  }

  headers() {
    return this.widths.map((_, index) => this.header(index));
  }

  separators() {
    return this.widths.map((_, index) => this.separator(index));
  }

  cellRows() {
    return range(this._rows.length)
      .map(rowIndex => this.cells(rowIndex));

  }

  cells(rowIndex) {
    return this.widths.map((_, index) => this.cell(rowIndex, index));
  }

  header(index) {
    const content = this._headers.hasOwnProperty(index) ? this._headers[index] : '';
    return padRight(content, this.widths[index]);
  }

  columnsWidths() {
    return this.widths;
  }

  separator(index) {
    return '-'.repeat(this.widths[index]);
  }

  firstCell() {
    const row = this._rows[0];
    if (row.hasOwnProperty(0)) {
      return row[0] || '';
    }
    return '';
  }

  cell(rowIndex, cellIndex) {
    const cellContent = () => {
      const row = this._rows[rowIndex];
      if (row.hasOwnProperty(cellIndex)) {
        return row[cellIndex];
      }
      return '';
    };

    return padRight(cellContent(), this.widths[cellIndex]);
  }
}

function columnWidths(rows) {
  const columnsCount = Math.max(...rows.map(row => row.length));
  return range(columnsCount)
    .map(index => Math.max(1, ...rows.map(row => {
      if (row.hasOwnProperty(index)) {
        return row[index].length;
      }
      return 1;
    })));
}

export function range(amount) {
  const values = [];
  for (let i = 0; i < amount; ++i) {
    values.push(i);
  }
  return values;
}

function padRight(string, length) {
  return string + ' '.repeat(length - string.length);
}
